// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"f2fadf89","516":"029304aa","675":"2dd11a0a","711":"663f663a"}[chunkId] + ".chunk.js";
};